/**
 * Comment form autohandler.
 *
 * Usage:
 *
 *  data-sw-comment=<product spin>
 */

var $ = require('./../sw-jquery');
var CommentForm = require('./../../lib/views/CommentForm');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-comment]').each(function() {
    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {

      var spin = $el.data('swComment');

      var product = ModelManager.getProduct(spin);

      new CommentForm({
        el: $el,
        model: product
      });

    });
  });

};
